module.exports = __webpack_public_path__ + "static/media/km.e979bec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/km.png
// module id = 1897
// module chunks = 0